import React from "react";
import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";

/**
 * MUI TextField wired to React Hook Form.
 *
 * Usage:
 *   <RHFTextField control={control} name="location" label="Location" required />
 *   <RHFTextField control={control} name="remarks" label="Remarks" multiline rows={3} />
 */
const RHFTextField = ({ control, name, label, defaultValue = "", ...props }) => (
  <Controller
    control={control}
    name={name}
    defaultValue={defaultValue}
    render={({ field, fieldState }) => (
      <TextField
        {...field}
        {...props}
        label={label}
        fullWidth
        value={field.value ?? ""}
        error={!!fieldState.error}
        helperText={fieldState.error?.message ?? props.helperText}
      />
    )}
  />
);

export default RHFTextField;
